import { graphql } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import ShareOnSocialMedia from '../components/ShareOnSocialMedia';
import Date from '../components/Date';
import { Link } from 'gatsby';
import newsroomSplash from '../images/news/newspaper.jpg';
import icbaGroupPhoto from '../images/news/icba-thinktech-group.jpg';
import AuthorJames from '../components/AuthorJames';
import DateAuthorSocial from '../components/DateAuthorSocial';
import ArticleTextOnly from '../components/ArticleTextOnly';
import NewsStoryHeader from '../components/NewsStoryHeader';

const Section = styled.section`
	color: black;
	display: flex;
	padding: 3em ${(props) => props.theme.paddingMobile};
	position: relative;
	z-index: 1;

	@media(${(props) => props.theme.mediumUp}) {
		padding: 3em ${(props) => props.theme.paddingMediumUp};
	}

	&.story {
		margin-top: -200px;
	}

	& article {
		padding-left: 0;
		padding-right: 0;
	}

	& figure {
		padding-left: 0;
		padding-right: 0;
	}

	& p {
		line-height: 1.6;
	}

`; // Section

const DateAuthor = styled.div`
	position: static;
`;

const IcbaThinkTechPage = (props: any) => {
	const {
		data: {
			site: {
				siteMetadata: { endpoint },
			},
		},
	} = props;

	const icbaHeaderContent = <article style={{marginTop: `22px`}}>
		<h1><Link to='/newsroom'>News</Link></h1>
	</article>;

	const icbaStoryURL = 'https://mkdecision.com/ICBA-ThinkTECH-Accelerator';
	const pageTitleBeginning = 'MK chosen as finalist for ICBA ThinkTECH Accelerator';

	return <Layout
		pageTitle={pageTitleBeginning}
		// headerSplashBg={newsroomSplash}
		headerContent={icbaHeaderContent}
		metaDescription={"MK Decision's Personal Loan Origination System (PLOS) is a platform for frictionless online loan origination"}
		headerSplashBgAverageColor={'#34414c'}
		CenteredSplashWrapperClass='newspaper'
		splashHeaderMinHeight={'320px'}
	>
		<div className='centeredWrapper'>
			<Section className='story row row-flush'>
				<NewsStoryHeader>
					<h2>MK chosen as finalist for ICBA ThinkTECH Accelerator</h2>
					<img src={icbaGroupPhoto} alt='MK has been selected by The Independent Community Bankers of America (ICBA) in partnership with The Venture Center and the State of Arkansas to participate in The ICBA ThinkTECH Accelerator.' />
				</NewsStoryHeader>
				<div className='date-social-text row row-flush'>
					<DateAuthorSocial>
						<DateAuthor>
							<Date>Jan 09, 2019</Date>
							<AuthorJames />
						</DateAuthor>
						<ShareOnSocialMedia
							mkNewsStoryURL={icbaStoryURL}
							title={pageTitleBeginning}
						/>
					</DateAuthorSocial>
					<ArticleTextOnly>
						<p>MK Decision - MK has been selected by The Independent Community Bankers of America (<a href='https://www.icba.org/'>ICBA&reg;</a>) in partnership with <a href='https://www.venturecenter.co/'>The Venture Center</a> and the State of Arkansas to participate in The ICBA ThinkTECH Accelerator.  MK is one of ten distinguished FinTech companies that attended the live-stream kickoff event on Jan. 9. Accelerator finalists were chosen from 190 applicant companies from 40 countries.  The finalists were selected for their innovative products that bring technology advancements to community banking.</p>
						<p><cite>"When we discovered MK, we knew that there was a unique opportunity to not only improve the customer credit card application process for community bank customers, but also to provide mentoring and guidance through their participation on the ICBA ThinkTECH Accelerator,"</cite> said Tina Giorgio, president and CEO of ICBA Bancard, the payment-services subsidiary of ICBA, a wholly owned payments and credit card company of ICBA. <cite>"We are excited to continue our work with MK to deliver a competitive product for our community bank customers that rivals the best marketplace lending tools available today."</cite></p>
						<p>MK will present at ICBA Live in Nashville, TN March 18-22. ICBA ThinkTECH Accelerator finalists will showcase their complete lending platform and expanded product suite to ICBA staff and bank executives from across the nation.  The San Diego FinTech will be highlighting their loan origination, automated decisioning, fraud prevention, and marketing products.  MK is confident in its platform's ability to deliver vastly higher conversion rates to any bank looking to issue credit cards, small business cards, and a variety of other loan types through a real-time online application.</p>
						<p><cite>"We're thrilled to be working with MK Decision and to have the opportunity to introduce it to the nation's community banks"</cite> said Kevin Tweddle, CPA and Chief Operating Officer, ICBA Services Network, <cite>"This game changing digital lending platform is a high-tech underwriting solution that leaves more room for high-touch community bank-customer relationships. By reducing the decision-making process down to seconds, community banks and their customers save valuable time without sacrificing the community bank quality service that they know and value."</cite></p>
						<p>MK's lending platform specifically addresses outdated origination technology, ever-increasing fraud rates, and the use of disorienting third party credit applications and interfaces.  Interfaces are both lender and customer-facing, and utilize machine-learning technologies to prevent fraud and flag repeat applications; making credit decisioning efficient for lenders, safe and easy for borrowers.</p>
						<p><cite>"The MK platform provides the customer experience and ease of use that consumers have come to expect from a financial institution"</cite> said Guru Dharam Khalsa, co-founder and COO of MK Decision, <cite>"Our mission is to equip community banks and lenders with top-notch technology that ensures safety from fraudsters while making the lending process as frictionless as possible."</cite></p>
						<p>MK has been diligently solving industry challenges by working closely with community banks, and listening to their needs. Scott Hamilton, former VP of Credit Card Management at Axiom Bank, said, <cite>"We partnered with MK to build a consumer credit card application and solid underwriting platform, on-time, and at a reasonable investment. And they delivered."</cite></p>
						<p>With a sturdy and efficient platform, MK Decision continues to roll out new products to impact the lending market, while making their mark as a rising star in the financial technology industry.</p>
						<p>Posted on January 29 in <Link to='/newsroom/'>News</Link></p>
						<p>Read more about MK in our <a href='https://mkdecision.com/blog/'>News</a></p>
					</ArticleTextOnly>
				</div>
			</Section>
		</div>
	</Layout>;
};

export default IcbaThinkTechPage;

export const pageQuery = graphql`
	query {

		site: site {
			siteMetadata {
				endpoint
			}
		}
	}
`;
